var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import store from '../../store';
import getColumns from './columns/getColumns';
import cleanUpRecordsForRpcConsumption from './utils/cleanUpRecordsForRpcConsumption';
import deepmerge from 'deepmerge';
export default function createRecords(entity, records, createParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const cols = getColumns(entity);
        const records2 = cleanUpRecordsForRpcConsumption(cols, records);
        // if tempted to change the following awekward construct, make sure you understand it. I don't. It may be required for backward compatibility
        const createParamsMerged = deepmerge(createParams || {}, { payload: { records: records2 } });
        const response = yield store.dispatch(entity + '/create', createParamsMerged.payload);
        return response;
    });
}
